import React from 'react';
import './why-attend-styles.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faLightbulb,
  faUsers,
  faCommentDots,
  faHeartbeat,
  faNetworkWired,
  faLaptopMedical,
} from '@fortawesome/free-solid-svg-icons';

export const WhyAttend = () => {
  return (
    <section className='why-attend-section pt-5'>
      <div className='why-attend-container'>
        <h2 className='expect-heading mb-4 bar'>Why You Should <span className='text-theme head-font '>Attend</span> </h2>

        <div className='why-attend-reasons'>
          <div className='reason-item '>
            <FontAwesomeIcon icon={faLightbulb} className='reason-icon' />
            <div className='reason-content'>
              <h3>Stay Informed</h3>
              <p>
                Learn about the latest tools, systems, and processes we’re
                implementing.
              </p>
            </div>
          </div>

          <div className='reason-item '>
            <FontAwesomeIcon icon={faUsers} className='reason-icon' />
            <div className='reason-content'>
              <h3>Collaborate</h3>
              <p>
                Engage with guest speakers and colleagues, sharing ideas and
                solutions that improve our work environment.
              </p>
            </div>
          </div>

          <div className='reason-item '>
            <FontAwesomeIcon icon={faCommentDots} className='reason-icon' />
            <div className='reason-content'>
              <h3>Get Involved</h3>
              <p>
                Provide feedback on session topics and contribute your
                suggestions for future sessions.
              </p>
            </div>
          </div>
        </div>

        <div className='why-attend-strategy'>
          <h2>
            All of this aligns with our strategic focus on{' '}
            <strong className='text-theme'>Joy@Work</strong>, where our goal is to:
          </h2>
          <div className='why-attend-reasons'>
            <div className='reason-item right'>
              <FontAwesomeIcon icon={faHeartbeat} className='reason-icon' />
              <div className='reason-content'>
                <h3>Enhance the Work Experience</h3>
                <p>
                  Through practical improvements and smarter use of technology.
                </p>
              </div>
            </div>

            <div className='reason-item left'>
              <FontAwesomeIcon icon={faNetworkWired} className='reason-icon' />
              <div className='reason-content'>
                <h3>Foster Collaboration</h3>
                <p>
                  Encourage open communication across departments and teams.
                </p>
              </div>
            </div>

            <div className='reason-item right'>
              <FontAwesomeIcon icon={faLaptopMedical} className='reason-icon' />
              <div className='reason-content'>
                <h3>Empower Staff</h3>
                <p>
                  Provide the knowledge and tools needed to deliver better care
                  and improve efficiency.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
